import { gsap } from "gsap";
import { Flip } from "gsap/Flip";

function initFilters() {
	gsap.registerPlugin(Flip);

	// clear filter button
	const clearFilterBtns = document.querySelectorAll(".clear-filters");
	clearFilterBtns.forEach((btn) =>
		btn.addEventListener("click", () => {
			// clear checkboxes
			[...document.querySelectorAll(".filter-checkbox")].forEach(
				(checkbox) => (checkbox.checked = false)
			);
			// clear params
			window.history.replaceState({}, "", `${location.pathname}`);
			setFiltersFromParams();

			updateHeader(btn, true);
		})
	);

	// show filters button (mobile)
	const showFiltersButton = document.querySelector("#show-filters");
	const filters = document.querySelector("#filters");
	showFiltersButton.addEventListener("click", (e) => {
		e.preventDefault();
		// toggle aria-expanded
		showFiltersButton.setAttribute(
			"aria-expanded",
			showFiltersButton.getAttribute("aria-expanded") === "true"
				? "false"
				: "true"
		);
		filters.classList.toggle("show");
	});

	setFiltersFromParams();

	let isScrolling;
	const imageCardGrid = document.querySelector(".image-card-grid");
	if (imageCardGrid) {
		window.addEventListener("scroll", function (event) {
			window.clearTimeout(isScrolling);
			imageCardGrid.classList.add("scrolling");
			isScrolling = setTimeout(function () {
				imageCardGrid.classList.remove("scrolling");
			}, 250);
		});
	}

	// set filter-description-default opacity to 1, visibility to visible
	const filterDescriptionDefault = document.querySelector(".filter-description-default");
	if (filterDescriptionDefault) {
		gsap.set(filterDescriptionDefault, { autoAlpha: 1, visibility: 'visible' });
	}
}

function setFiltersFromParams() {
	// check params and set checkboxes
	let params = new URLSearchParams(window.location.search);

	if (document.querySelectorAll(".clear-filter-container").length > 0) {
		if (document.querySelectorAll(".filter-sub-section.active").length === 0) {
			document
				.getElementsByClassName("clear-filter-container")[0]
				.classList.remove("show");
		} else {
			document
				.getElementsByClassName("clear-filter-container")[0]
				.classList.add("show");
		}
	}

	// for each set of filter
	const filterSubSections = [
		...document.querySelectorAll(".filter-sub-section"),
	];

	filterSubSections.forEach((filter) => {
		// if filter category is in params, set checkboxes
		const activeUrlParams = params
			.get(filter.querySelector("h4").dataset.filterCategory)
			?.split(",");
		const filterCheckboxes = [...filter.querySelectorAll(".filter-checkbox")];
		const filterInputs = [...filter.querySelectorAll(".filter-label")];
		let currentCheckboxState = false;

		filterInputs.forEach((input) =>
			input.addEventListener("mouseover", function (event) {
				currentCheckboxState = input.querySelector(".filter-checkbox").checked;
			})
		);
		filterCheckboxes.forEach((btn) =>
			btn.addEventListener("click", function () {
				if (currentCheckboxState) {
					btn.checked = false;
					currentCheckboxState = false;
					updateHeader(btn, true);
				} else {
					let checkedBoxes = [
						...document.querySelectorAll(".filter-checkbox"),
					];
					for (let checkbox of checkedBoxes) {
						checkbox.checked = false;
						btn.checked = true;
					}
					updateHeader(btn, false);
				}
				filterGrid();
			})
		);

		if (!activeUrlParams) {
			return;
		}
		filterCheckboxes.forEach((checkbox) => {
			if (activeUrlParams.includes(checkbox.dataset.filterName)) {
				checkbox.checked = true;
			}
		});
	});
	filterGrid();
}


function updateHeader(btn, reset = false) {
	if (window.innerWidth < 768) {
		window.scrollTo(0, 0);
	}
	const header = document.querySelector(".architecture-design-title > .h4");
	const wrapper = document.querySelector(".filter-description");
	if(!wrapper) return;
	
	const filterDescriptionDefault = wrapper.querySelector(".filter-description-default");
	const categoryDescription = wrapper.querySelector(`#description-${btn.dataset.filterName}`);
	const activeCategoryDescription = wrapper.querySelector(".active-description");

	if (reset ) { 
		if(activeCategoryDescription) {
			gsap.to(header, { autoAlpha: 0, duration: 0.4 }).then(() => {
				header.textContent = "Work";
			});
			gsap.to(header, { autoAlpha: 1, display: 'block', duration: 0.6, delay: 0.2, ease: "power1.out"}, '>');

			gsap.to(activeCategoryDescription, { autoAlpha: 0, display: 'none', duration: 0.4 }).then(() => {
				activeCategoryDescription.classList.remove("active-description");
			}).then(() => {
				filterDescriptionDefault.classList.add("active-description");
				gsap.to(filterDescriptionDefault, { autoAlpha: 1, display: 'block', duration: 0.6, delay: 0.4, ease: "power1.out" });
			});
		}


	} else {
		const newHeader = btn.nextElementSibling.textContent;
		gsap.to(header, { autoAlpha: 0, duration: 0.4 }).then(() => {
			header.textContent = newHeader;
		});
		gsap.to(header, { autoAlpha: 1, display: 'block', duration: 0.6, delay: 0.2, ease: "power1.out" }, '>');

		// hide active description
		gsap.to(activeCategoryDescription, { autoAlpha: 0, display: 'none', duration: 0.4}).then(() => {
			activeCategoryDescription.classList.remove("active-description");
		}).then(() => {
			categoryDescription.classList.add("active-description");
				
			gsap.to(categoryDescription, { autoAlpha: 1, display: 'block', duration: 0.6, delay: 0.4, ease: "power1.out" });
		});

	}

}


function filterGrid() {
	const items = [...document.querySelectorAll(".image-card-grid .image-card")];
	const filterSubSections = [
		...document.querySelectorAll(".filter-sub-section"),
	];

	const state = Flip.getState(items);
	params = new URLSearchParams(window.location.search);

	// for each filter, get the active checkboxes and set URL params
	const filterArray = filterSubSections.map((filter) => {
		const heading = filter.querySelector("h4").dataset.filterCategory; //.textContent.toLowerCase();
		const activeFilters = [...filter.querySelectorAll(".filter-checkbox")]
			.filter((checkbox) => checkbox.checked)
			.map((checkbox) => checkbox.dataset.filterName);

		params.delete(heading);
		const activeAllFilters  = [...filters.querySelectorAll(".filter-checkbox:checked")]
		if (activeAllFilters.length > 0) {
			filters.classList.add("active");
		} else {
			filters.classList.remove("active");
		}
		if (activeFilters.length > 0) {
			params.set(heading, activeFilters.join(","));
		}

		if (document.querySelectorAll(".clear-filter-container").length > 0) {
			if (
				document.querySelectorAll("#filters.active").length === 0
			) {
				document
					.getElementsByClassName("clear-filter-container")[0]
					.classList.remove("show");
			} else {
				document
					.getElementsByClassName("clear-filter-container")[0]
					.classList.add("show");
			}
		}

		if (!document.querySelectorAll(".page-people").length > 0) {
			window.history.replaceState(
				{},
				"",
				`${location.pathname}?${params.toString().replace(/%2C/g, ",")}`
			); // commas more readable than %2C, don't use them in categories anyway
		}
		return activeFilters;
	});

	items.forEach((item) => {
		const results = filterArray?.map((filterList) => {
			if (document.querySelectorAll(".page-people").length > 0) {
				return filterList.length
					? filterList.some((filter) =>
							item.dataset.categories?.trim().split(",").includes(filter)
					  )
					: true;
			} else {
				return filterList.length
					? filterList.some((filter) =>
							item.dataset.categories?.trim().split(" ").includes(filter)
					  )
					: true;
			}
		});

		results.every(Boolean)
			? item.classList.remove("hidden")
			: item.classList.add("hidden");
	});

	const numRemainingItems = [
		...document.querySelectorAll(".image-card-grid .image-card:not(.hidden)"),
	].length;
	if (numRemainingItems === 0) {
		document.querySelector(".no-filter-results").classList.add("show");
	} else {
		document.querySelector(".no-filter-results").classList.remove("show");
	}

	Flip.from(state, {
		duration: 0.4,
		ease: "power3.out",
		prune: true,
		absolute: false,
		absoluteOnLeave: true,
		onEnter: (elements) =>
			gsap.fromTo(
				elements,
				{ opacity: 0 },
				{ opacity: 1, ease: "power3.out", duration: 0.4 }
			),
		onLeave: (elements) =>
			gsap.to(elements, { opacity: 0, ease: "power3.out", duration: 0.4 }),
	});

	// if (filterArray[0].length > 0 || filterArray[1].length > 0) {
	// 	scrollToFiltered();
	// }
}

document.addEventListener("DOMContentLoaded", function () {
	const filters = document.querySelector("#filters");
	if (filters) initFilters();
});

// function scrollToFiltered() {
// 	const headerOffset = 100;
// 	const elementPosition = document
// 		.getElementById("filter-grid")
// 		.getBoundingClientRect().top;

// 	const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

// 	window.scrollTo({
// 		top: offsetPosition,
// 		behavior: "smooth",
// 	});
// }
